<script>
/* eslint-disable */
import cities from "@/assets/json/addressData.json";
import axios from "axios";

export default {
	name: "assistant",
	props: {
		isActiveAssistant: {
			type: Boolean,
			required: true,
		},
		isActiveSuccess: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			userInfo: {
				lastname: "",
				firstname: "",
				mobile: "",
				gender: "",
				countyIndex: 0,
				districtIndex: 0,
				contact_way: "",
				contact_time: "",
				dealer: "",
				address_detail: "",
				email: "",
				"g-recaptcha-response": "",
			},
			// userInfo: {
			// 	lastname: "liao",
			// 	firstname: "py",
			// 	mobile: "0900000000",
			// 	gender: "0",
			// 	countyIndex: 1,
			// 	districtIndex: 5,
			// 	contact_way: "手機",
			// 	contact_time: "下午13:00~17:00",
			// 	dealer: "桃園大桐",
			// 	address_detail: "address",
			// 	email: "test@gmail.com",
			// 	"g-recaptcha-response": "",
			// },
			formData: {},
			isLockBtn: false,
		};
	},
	computed: {
		cities() {
			return cities;
		},
		areas() {
			return cities[this.userInfo.countyIndex].areas;
		},
	},
	watch: {
		"userInfo.countyIndex": {
			handler: function () {
				const _this = this;
				_this.userInfo.districtIndex = 0;
			},
		},
		isActiveAssistant: function (newV) {
			const _this = this;
			_this.$nextTick(() => {
				if (newV && !document.getElementById("g-recaptcha-response")) {
					_this.captchaCallback();
				}
			});
		},
	},
	mounted() {},
	methods: {
		checkForm() {
			// console.log("checkForm", "Assistant");
			const _this = this;

			if (!_this.userInfo.lastname) {
				alert("請填寫您的姓氏");
				const element =
					document.querySelector(".assistant #lastname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!_this.userInfo.firstname) {
				alert("請填寫您的名字");
				const element =
					document.querySelector(".assistant #firstname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!_this.userInfo.gender) {
				alert("請選擇您的稱謂");
				const element =
					document.querySelector(".assistant #gender").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!_this.userInfo.mobile) {
				alert("請填寫您的手機號碼");
				const element =
					document.querySelector(".assistant #mobile").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validMobile = /^09\d{8}$/;
				if (!validMobile.test(_this.userInfo.mobile)) {
					alert("手機號碼格式錯誤");
					return false;
				}
			}
			if (_this.userInfo.countyIndex === 0) {
				alert("請選擇縣市");
				const element =
					document.querySelector(".assistant #county").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!_this.userInfo.address_detail) {
				alert("請填寫您的詳細地址");
				const element = document.querySelector(".assistant #address_detail").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!_this.userInfo.email) {
				alert("請填寫您的E-mail");
				const element =
					document.querySelector(".assistant #email").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validEmail =
					/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if (!validEmail.test(_this.userInfo.email)) {
					alert("E-mail格式錯誤");
					return false;
				}
			}
			if (!_this.userInfo.contact_way) {
				alert("請選擇方便聯絡方式");
				const element = document.querySelector(".assistant #contact_mobile").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (_this.userInfo.contact_way === "手機" && !_this.userInfo.contact_time) {
				alert("請選擇方便聯絡時間");
				const element = document.querySelector(".assistant #contact_time1").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (_this.userInfo["g-recaptcha-response"] === "") {
				alert("請勾選我不是機器人");
				return false;
			}

			_this.isLockBtn = true;
			_this.sendData();
		},
		sendData() {
			// console.log("sendData", "Assistant");
			const _this = this;

			_this.formData = new FormData();
			_this.formData.append("userlastname", _this.userInfo.lastname);
			_this.formData.append("userfirstname", _this.userInfo.firstname);
			_this.formData.append("gender", _this.userInfo.gender);
			_this.formData.append("tel", _this.userInfo.mobile);
			_this.formData.append("county", _this.cities[_this.userInfo.countyIndex].name);
			_this.formData.append(
				"district",
				_this.cities[_this.userInfo.countyIndex].areas[_this.userInfo.districtIndex].name,
			);
			_this.formData.append("address", _this.userInfo.address_detail);
			_this.formData.append("email", _this.userInfo.email);
			_this.formData.append("contact", _this.userInfo.contact_way);
			_this.formData.append(
				"contact_time",
				_this.userInfo.contact_way === "手機" ? _this.userInfo.contact_time : "",
			);
			_this.formData.append("dealer", _this.userInfo.dealer);
			_this.formData.append(
				"remarks",
				_this.userInfo.remarks === "" ? _this.userInfo.remarks : "無",
			);
			_this.formData.append("g-recaptcha-response", _this.userInfo["g-recaptcha-response"]);

			axios
				.post("/secondhand/SearchProcess", _this.formData)
				.then(function (response) {
					if (response.data.status === 0) {
						_this.userInfo = {};
						_this.userInfo = {
							lastname: "",
							firstname: "",
							mobile: "",
							gender: "",
							countyIndex: 0,
							districtIndex: 0,
							contact_way: "",
							contact_time: "",
							dealer: "",
							address_detail: "",
							email: "",
						};
						_this.$emit("update:isActiveAssistant", false);
						_this.$emit("update:isActiveSuccess", true);
						grecaptcha.reset(recaptchaAssistant);
					} else {
						alert(response.data.message);
					}
					_this.isLockBtn = false;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		assistantToggle() {
			// console.log("assistantToggle", "Assistant");
			const _this = this;
			_this.$emit("update:isActiveAssistant", false);
		},
		captchaCallback() {
			// console.log("captchaCallback");
			const _this = this;
			grecaptcha.render("recaptchaAssistant", {
				sitekey: "6LdVoSwUAAAAAGuuSZsflmO-v2VBywYBK6xVISQd",
				theme: "light",
				callback: _this.verifyCallback,
			});
		},
		verifyCallback(token) {
			// console.log("verifyCallback");
			const _this = this;
			_this.userInfo["g-recaptcha-response"] = token;
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
